import { Moment } from 'moment';
import DriveBookingStatus from '../constants/DriveBookingStatus';
import DriveBookingType from '../constants/DriveBookingType';
import DriveAsset from './DriveAsset';
import DriveBookingInvoiceStatus from '../constants/DriveBookingInvoiceStatus';

export default class DriveBooking {
  id!: number;
  mediaCount = 0;
  status!: DriveBookingStatus;
  type: DriveBookingType | null = null;
  scheduledFrom: Moment | null = null;
  scheduledTill: Moment | null = null;
  checkOutOn: Moment | null = null;
  checkInOn: Moment | null = null;
  asset: DriveAsset | null = null;
  lastSynchronizedOn: Moment | null = null;
  lastSynchronizedBy: string | null = null;
  modifiedOn: Moment | null = null;
  invoiceStatus!: DriveBookingInvoiceStatus;

  static create(
    id: number,
    mediaCount: number,
    status: DriveBookingStatus,
    type: DriveBookingType,
    scheduledFrom: Moment,
    scheduledTill: Moment,
    asset: DriveAsset,
    lastSynchronizedOn: Moment,
    lastSynchronizedBy: string,
    checkOutOn: Moment,
    checkInOn: Moment,
    modifiedOn: Moment,
    invoiceStatus: DriveBookingInvoiceStatus,
  ): DriveBooking {
    const booking = new DriveBooking();
    booking.id = id;
    booking.mediaCount = mediaCount;
    booking.status = status;
    booking.type = type;
    booking.scheduledFrom = scheduledFrom;
    booking.scheduledTill = scheduledTill;
    booking.asset = asset;
    booking.lastSynchronizedOn = lastSynchronizedOn;
    booking.lastSynchronizedBy = lastSynchronizedBy;
    booking.checkOutOn = checkOutOn;
    booking.checkInOn = checkInOn;
    booking.modifiedOn = modifiedOn;
    booking.invoiceStatus = invoiceStatus;
    return booking;
  }

  updateSynchronizationInfo(
    lastSynchronizedOn: Moment | null,
    lastSynchronizedBy: string | null,
  ): void {
    this.lastSynchronizedOn = lastSynchronizedOn;
    this.lastSynchronizedBy = lastSynchronizedBy;
  }
}
